import { useMutation } from '@apollo/client';
import { TRIGGER_SCORING } from '@gql/scoring';
import { TriggerScoringInput, TriggerScoringResult } from '../types';

export const useTriggerScoring = () => {
    const [mutate, { loading, error }] = useMutation<
        { triggerScoring: TriggerScoringResult },
        { input: TriggerScoringInput }
    >(TRIGGER_SCORING);

    const triggerScoring = async (input: TriggerScoringInput): Promise<TriggerScoringResult | null> => {
        try {
            const { data } = await mutate({ variables: { input } });
            return data?.triggerScoring ?? null;
        } catch {
            return null;
        }
    };

    return { triggerScoring, loading, error };
};
